import styled from 'styled-components';
import media from '../../components/base/media';
import { ulStyles, liStyles } from '../../components/base';

export const Wrapper = styled.div`
	padding: 6rem 0;
	padding-top: calc(${props => props.theme.header.headerHeightMobile} + 6rem);

	${media.desktopSmall`
		padding: 18rem 0;
	`}

	${media.desktopLarge`
		padding: 28rem 0 22rem 0;
	`}


	p {
		margin-bottom: 1rem;
	}

	ul {
		${ulStyles};

		li {
			${liStyles};
		}
	}
`;

export const Content = styled.div`
	${media.desktopSmall`
		max-width: 118rem;
	`}
`;
